import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { FulfillmentGroupData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { LearnedPresetKind } from "@redotech/redo-model/outbound-labels/learned-preset";

export function getOptimisticUpdates(
  originalData: FulfillmentGroupData[],
  updates: FulfillmentGroupUpdate[],
) {
  const newData = [...originalData];
  for (const { fulfillmentGroupId, ...rest } of updates) {
    const index = newData.findIndex((row) => row._id === fulfillmentGroupId);
    if (index < 0) {
      continue;
    }
    const update: Partial<FulfillmentGroupData> = { ...rest };
    if (
      rest.selectedParcels ||
      rest.signatureRequired != null ||
      rest.adultSignatureRequired != null ||
      rest.customsDeclarations ||
      rest.contentsType ||
      rest.contentsExplanation ||
      rest.nonDeliveryOption ||
      rest.uspsExemptionCode ||
      rest.taxIdentifierIds ||
      rest.itn ||
      rest.ddp != null ||
      rest.hazmat !== undefined ||
      rest.dryIceWeight !== undefined ||
      rest.specialRateEligibility !== undefined || // undefined means we are not updating it, null means we are turning off all special rate eligibility
      rest.assignedFulfillmentService ||
      rest.shipmentPaymentOption !== undefined ||
      rest.directDeliveryOnly !== undefined ||
      rest.carbonNeutral !== undefined ||
      rest.additionalCustomsComments !== undefined ||
      rest.overrideResidentialAddress !== undefined
    ) {
      update.ratesPendingSince = new Date();
    }
    newData[index] = { ...newData[index], ...update };
    if (rest.overrideDeliveryMethod) {
      newData[index].deliveryMethod = rest.overrideDeliveryMethod;
    }
    if (rest.displayWeightGrams && newData?.[index]?.usedLearning != null) {
      newData[index].usedLearning[LearnedPresetKind.WEIGHT] = false;
    }
    if (rest.selectedParcels && newData?.[index]?.usedLearning != null) {
      newData[index].usedLearning[LearnedPresetKind.PARCEL] = false;
    }
    const weightOverrideChanged = rest.selectedParcels?.some(
      (parcel) => parcel.parcelAndContentWeight !== undefined,
    );
    if (weightOverrideChanged && newData?.[index]?.usedLearning != null) {
      newData[index].usedLearning[LearnedPresetKind.WEIGHT] = false;
    }
    if (
      (rest.selectedShippingRate || rest.selectedShippingRate === null) &&
      newData?.[index]?.usedLearning != null
    ) {
      newData[index].usedLearning[LearnedPresetKind.CARRIER_SERVICE_LEVEL] =
        false;
    }
  }
  return { newData, updates };
}
